import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { Button } from './../common';
import styles from './YearEvents.css';
import YearEventObject from './YearEventObject/YearEventObject';

const YearEvents = ({ year, month, changeFocusDateTo, eventsByType }) => {
  const isPassed = new Date(year, month + 1) < new Date();

  return (
    <Button
      onClick={() => changeFocusDateTo(new Date(year, month, 16))}
      className="Event"
    >
      <ul
        className={styles.EventButtonList}
      >
        {Object.keys(eventsByType).map(k => (
          <YearEventObject
            key={uuidv4()}
            gameType={k}
            gameCount={eventsByType[k]}
            isPassed={isPassed}
          />
        ))}
      </ul>
    </Button>
  );
};

YearEvents.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  changeFocusDateTo: PropTypes.func.isRequired,
  eventsByType: PropTypes.shape().isRequired
};

export default YearEvents;



// WEBPACK FOOTER //
// ./src/components/YearEvents/YearEvents.js